import { useEffect } from "react";
import { useNavigate } from "@/router";
import useCurrentUser from "@/hooks/useCurrentUser";
import TasksTabContent from "../../_components/TasksTabContent";

export default function DepartmentTasksPage() {
  const navigate = useNavigate();
  const { user } = useCurrentUser();
  const userDepartment = user?.department;

  useEffect(() => {
    if (user && !userDepartment) {
      navigate("/tasks/my-tasks", { replace: true });
    }
  }, [user, userDepartment, navigate]);

  if (!userDepartment) {
    return null;
  }

  return (
    <TasksTabContent
      body={`View and manage tasks tagged for the ${userDepartment} team`}
      source="department_tasks_tab"
      queryOptions={{ fixedDepartment: userDepartment, useTeamTagForDepartment: true, showUnassignedChip: true }}
    />
  );
}
